import { Component, Input, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'topo-text-column',
    templateUrl: './text-column.component.html',
    styleUrls: ['./text-column.component.scss'],
    standalone: false
})
export class TextColumnComponent implements OnInit, DynamicColumn {
  FORMAT_TEXT_SINGLELINE = 'FORMAT-TEXT-SINGLELINE';
  FORMAT_TEXT_MULTILINE = 'FORMAT-TEXT-MULTILINE';

  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }

  get format(): string {
    let textFormat = this.field?.settings?.format;
    if (!textFormat) {
      textFormat = 'FORMAT_TEXT_SINGLELINE';
    }

    return textFormat;
  }
}
